/**
 * The in-app path to return to after login, read from the `redirect` search param.
 * Only a same-origin absolute path is trusted — a full URL or a protocol-relative
 * `//host` (or `/\host`, which browsers read the same way) would make login an open redirect.
 */
export const getSafeRedirectPath = (raw?: string | null): string | undefined =>
  raw && raw.startsWith('/') && !raw.startsWith('//') && !raw.startsWith('/\\') ? raw : undefined;
